// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"BasketLayout_backdrop__3jLIs","wrapper":"BasketLayout_wrapper__4ommh"};